<template>
  <div class="animated fadeIn">
    <div>
      <b-alert
        class="btn mr-4 mt-2"
        :show="dismiss2CountDown"
        fade
        variant="success"
        :dismissed="(dismiss2Countdown = 0)"
        @dismiss-count-down="countDown2Changed"
      >
        PO Number: {{ shipping.shipping_scan_edit.PONumber }}<br />
        Tracking information has been saved.
        <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
      </b-alert>
    </div>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <CoolSelect
            v-model="shipping.current_ship_method"
            placeholder="Ship Method"
            theme="bootstrap"
            tooltip="Ship Method"
            :items="shipping.shipping_methods"
            item-text="ShippingMethodName"
            item-value="ShippingMethodName"
            id="ShippingMethodName"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth"
                  >Ship Method</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Order ID</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-focus
                    v-model="shipping.shipping_scan_edit.PONumber"
                    autocomplete="off"
                    type="text"
                    id="OrderID"
                    ref="OrderID"
                    @change.native="loadOrder"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Tracking Number</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="new_tracking_number"
                    autocomplete="off"
                    type="text"
                    id="TrackingNumber"
                    @change.native="postNotification"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="shipping.shipping_scan_edit.TotalKits" />
          <hr v-if="shipping.shipping_scan_edit.TotalKits" />
          <KitImageGroup
            v-for="(n, i) in shipping.shipping_scan_edit.TotalKits"
            v-bind:key="n"
            :is_n_of="n"
            :of_total="shipping.shipping_scan_edit.TotalKits"
          >
          </KitImageGroup>
          <b-row
            class="border-bottom m-2 pb-2"
            v-if="shipping.shipping_scan_edit.ExtraCAPs > 0"
          >
            <b-col md="2" class="font-weight-bold"
              >Extra CAPs ({{ shipping.shipping_scan_edit.ExtraCAPs }})</b-col
            >
            <b-col v-for="n in shipping.shipping_scan_edit.ExtraCAPs" md="2">
              <img
                width="80"
                src="https://dashboard.icap-maker.com/img/shipping/CAP.jpg"
              />
            </b-col>
          </b-row>
          <b-row
            class="border-bottom m-2 pb-2"
            v-if="shipping.shipping_scan_edit.ExtraNoteCards > 0"
          >
            <b-col md="2" class="font-weight-bold"
              >Extra Notecards ({{
                shipping.shipping_scan_edit.ExtraNoteCards
              }})</b-col
            >
            <b-col
              v-for="n in shipping.shipping_scan_edit.ExtraNoteCards"
              md="2"
            >
              <img
                width="80"
                src="https://dashboard.icap-maker.com/img/shipping/NoteCard.jpg"
              />
            </b-col>
          </b-row>
          <b-row
            class="border-bottom m-2 pb-2"
            v-if="shipping.shipping_scan_edit.ExtraStickers > 0"
          >
            <b-col md="2" class="font-weight-bold"
              >Extra Stickers ({{
                shipping.shipping_scan_edit.ExtraStickers
              }})</b-col
            >
            <b-col
              v-for="n in shipping.shipping_scan_edit.ExtraStickers"
              md="2"
            >
              <img
                width="80"
                src="https://dashboard.icap-maker.com/img/shipping/Stickers.jpg"
              />
            </b-col>
          </b-row>
          <hr v-if="shipping.shipping_scan_edit.TotalKits" />
          <hr v-if="shipping.shipping_scan_edit.TotalKits" />
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Customer ID</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.BuffiniCustomerID"
                    autocomplete="off"
                    type="text"
                    id="WebCustomerID"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Received</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.DateOrdered"
                    autocomplete="off"
                    type="text"
                    id="Quantity"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">CAP/IOV</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.CAP"
                    autocomplete="off"
                    type="text"
                    id="CAP"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <a
                    :href="artworkLink"
                    style="width:250px;"
                    target="_blank"
                    class="btn btn-success"
                    role="button"
                  >
                    Download Hi-Res PDF
                    <i class="fa fa-download appendIcon"></i>
                  </a>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>-->

          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Delivered To</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipName1"
                    autocomplete="off"
                    type="text"
                    id="ship_name"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Company</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipName2"
                    autocomplete="off"
                    type="text"
                    id="ship_name"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipAddress1"
                    autocomplete="off"
                    type="text"
                    id="ship_address_1"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Ste./Bldg</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipAddress2"
                    autocomplete="off"
                    type="text"
                    id="ship_address_2"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >City</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipCity"
                    autocomplete="off"
                    type="text"
                    id="ship_city"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >State/Province</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipState"
                    autocomplete="off"
                    type="text"
                    id="ship_state"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Postal Code</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipPostalCode"
                    autocomplete="off"
                    type="text"
                    id="ship_postal_code"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Country</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ShipCountry"
                    autocomplete="off"
                    type="text"
                    id="ship_country"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Shipping Method</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_scan_edit.ship_method"
                    autocomplete="off"
                    type="text"
                    id="ship_method"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>-->
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-button
                    style="width:200px;"
                    size="md"
                    variant="primary"
                    @click="back"
                  >
                    <i class="fa fa-arrow-left"></i>
                    Close Order Detail
                  </b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="isICap || isMCap">
              <b-form-group>
                <b-input-group>
                  <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                  <a
                    :href="artworkLink"
                    target="_blank"
                    class="btn btn-success"
                    style="width:200px;"
                    role="button"
                  >
                    Download IOV Artwork
                    <!-- <i class="fa fa-search appendIcon"></i> -->
                  </a>
                  <a
                    v-if="hasCoverLetter"
                    :href="mcapArtworkLink"
                    target="_blank"
                    class="btn btn-success ml-3"
                    style="width:200px;"
                    role="button"
                  >
                    Download Cover Letter
                    <!-- <i class="fa fa-search appendIcon"></i> -->
                  </a>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-tabs>
                <b-tab active>
                  <template slot="title">
                    <i class="fa fa-cog"></i>
                    <span class="ml-1">Kit Information</span>
                  </template>
                  <br />
                  <b-list-group>
                    <b-list-group-item>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Kit Type</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="shipping.shipping_scan_edit.KitType"
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Culture</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="shipping.shipping_scan_edit.Culture"
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Fulfillment Type</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="
                                  shipping.shipping_scan_edit.FulfillmentType
                                "
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Extra Full Kits</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="
                                  shipping.shipping_scan_edit.ExtraFullKits
                                "
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Extra Caps</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="shipping.shipping_scan_edit.ExtraCAPs"
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Extra Notecards</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="
                                  shipping.shipping_scan_edit.ExtraNoteCards
                                "
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-input-group-text class="standardizedWidth"
                                  >Extra Stickers</b-input-group-text
                                >
                              </b-input-group-prepend>
                              <b-form-input
                                v-model="
                                  shipping.shipping_scan_edit.ExtraStickers
                                "
                                autocomplete="off"
                                type="text"
                                id="ship_country"
                              ></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group>
                            <b-input-group v-if="hasTrackingInfo">
                              <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                              <a
                                :href="trackingLink"
                                target="_blank"
                                class="btn btn-orange"
                                style="width:250px;"
                                role="button"
                              >
                                Track this package
                                <i class="fa fa-search appendIcon"></i>
                              </a>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                  </b-list-group>
                </b-tab>
                <b-tab>
                  <template slot="title">
                    <i class="fa fa-cog"></i>
                    <span class="ml-1">Production Activtiy</span>
                  </template>
                  <br />
                  <b-list-group>
                    <b-list-group-item>
                      <b-row>
                        <b-col md="2">
                          <b>Status Event</b>
                        </b-col>
                        <b-col md="2">
                          <b>Time Stamp</b>
                        </b-col>
                        <b-col md="1">
                          <b>Carrier</b>
                        </b-col>
                        <b-col md="1">
                          <b>Method</b>
                        </b-col>
                        <b-col md="1">
                          <b>Cartons</b>
                        </b-col>
                        <b-col md="1">
                          <b>Weight</b>
                        </b-col>
                        <b-col md="4">
                          <b>Tracking Number</b>
                        </b-col>
                      </b-row>
                    </b-list-group-item>
                    <ShipStatusRow
                      v-for="activity in shipping.shipping_scan_edit.Activity"
                      :key="activity.ShippingStatusID"
                      :activity="activity"
                    />
                  </b-list-group>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ShipStatusRow from "@/components/CustomRowComponents/ShipStatusRow.vue";
import KitImageGroup from "@/components/ImageGroups/KitImageGroup.vue";
import { CoolSelect } from "vue-cool-select";

export default {
  name: "OneTimeOrder",
  data() {
    return {
      selected: [], // Must be an array reference!
      new_tracking_number: "",
      dismiss2Secs: 4,
      dismiss2CountDown: 0,
      hasCoverLetter: false
    };
  },
  methods: {
    async countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
      if (this.dismiss2CountDown == 0) {
        await this.$store.dispatch("shipping/resetScanEdit");
        this.new_tracking_number = "";
        this.$refs["OrderID"].focus();
        //console.log(this.$refs);
      }
    },
    async postNotification() {
      //this.$router.go(-1);
      console.log(this.$store.state.shipping.shipping_scan_edit);
      console.log(this.$store.state.shipping.current_ship_method);
      var _notification = {
        OrderID: this.$store.state.shipping.shipping_scan_edit.PONumber,
        StatusCode: "Complete",
        NumCartons: "1",
        TotalWeight: this.$store.state.shipping.shipping_scan_edit.TotalWeight,
        TrackingNumber: this.new_tracking_number,
        Notes: "LL Printers",
        ShipCarrier: "FedEx",
        ShipMethod: this.$store.state.shipping.current_ship_method
      };
      //console.log(_notification);
      await this.$store.dispatch("shipping/postScan", _notification);
      this.dismiss2CountDown = this.dismiss2Secs;
    },
    back() {
      this.$router.go(-1);
    },
    loadArtwork() {},
    async loadOrder(event) {
      //alert(event.target.value);
      await this.$store.dispatch("shipping/loadScanEdit", event.target.value);
    }
  },
  created() {
    this.$store.dispatch("shipping/shippingMethods");
    this.$store.dispatch("shipping/resetScanEdit");
  },
  computed: {
    ...mapState(["shipping", "n_user"]),
    artworkLink() {
      return (
        "https://proofs.icap-maker.com/GetHistoricalpdf.aspx?OrderID=" +
        this.$store.state.shipping.shipping_scan_edit.PONumber
      );
    },
    mcapArtworkLink() {
      return (
        "https://dashboard.icap-maker.com/CoverLetters/" +
        this.$store.state.shipping.shipping_scan_edit.BuffiniCustomerID +
        "-Letter.pdf"
      );
    },
    hasTrackingInfo() {
      return this.$store.state.shipping.shipping_scan_edit.TrackingNumber;
    },
    trackingLink() {
      return (
        "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=" +
        this.$store.state.shipping.shipping_scan_edit.TrackingNumber
      );
    },
    isICap() {
      return (
        this.$store.state.shipping.shipping_scan_edit.FulfillmentType === "I"
      );
    },
    isMCap() {
      return (
        this.$store.state.shipping.shipping_scan_edit.FulfillmentType === "M"
      );
    }
  },
  components: {
    ShipStatusRow,
    KitImageGroup,
    CoolSelect
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
